.dividerWrapper {
  display: flex;
  align-items: center;
}

.divider {
  border-color: var(--cxy-color-border-input);
  width: 100%;
}

.text {
  font-family: var(--cxy-font-family-sans);
  color: var(--cxy-color-border-input);
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-medium);
  line-height: 14.06px;
  text-transform: uppercase;
  margin-inline: var(--cxy-spacing-xxsm);
}
